import React from 'react';

const Header = () => {
  return (
    <h1>
            HAPPY THOUGHTS!
    </h1>
  )
};

export default Header;